var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-payment-method-card", [
    _c("div", { staticClass: "payment-content" }, [
      _c("div", { staticClass: "title" }, [
        _c("span", { style: { flexGrow: 1 } }, [
          _vm._v(
            _vm._s(_vm.cardLabel(_vm.mandat)) +
              _vm._s(_vm.mandat.details.cardNumber)
          ),
        ]),
        _vm.mandat.isActive && _vm.mandat.status == "valid"
          ? _c("span", { staticClass: "payment-active" }, [
              _vm._v(_vm._s(_vm.$ct("payment-methods.active"))),
            ])
          : _vm._e(),
        _vm.mandat.status !== "valid"
          ? _c("span", { staticClass: "payment-expired" }, [
              _vm._v(_vm._s(_vm.$ct("payment-methods.expired"))),
            ])
          : _vm._e(),
      ]),
      _vm.mandat.details.cardExpiryDate
        ? _c("p", { staticClass: "expires" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$ct("payment-methods.expires")) +
                " " +
                _vm._s(_vm._f("localDate")(_vm.mandat.details.cardExpiryDate)) +
                " "
            ),
          ])
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "footer" },
      [
        !_vm.mandat.isActive && !_vm.isDemo
          ? _c(
              "w-button",
              {
                staticClass: "info",
                style: { border: "none" },
                on: {
                  click: function ($event) {
                    return _vm.activateMandate(_vm.mandat)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("payment-methods.activate")) + " ")]
            )
          : _c("w-fa", {
              staticClass: "payment-icon",
              attrs: { icon: ["far", "credit-card"] },
            }),
        _c("w-spacer"),
        !_vm.mandat.isActive
          ? _c(
              "w-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.deleteMandate(_vm.mandat)
                  },
                },
              },
              [_c("w-fa", { attrs: { icon: "trash" } })],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }